import React from "react";
import { connect } from 'react-redux';
import { isDefined } from "../../../utils";

class RadioOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptionId: undefined
        };
        this.onSelectOption = this.onSelectOption.bind(this);
    }

    componentDidMount() {
        const
            {
                options
            } = this.props;

        if (!options || !Array.isArray(options)) {
            return;
        }
        const defaultSelectedOption = options.find(o => o.isDefaultSelected === true);
        if (isDefined(defaultSelectedOption)) {
            this.setState({
                selectedOptionId: defaultSelectedOption.id
            });
        }
    }

    //isDefaultSelected

    onSelectOption(selectedOption) {
        this.setState({ selectedOptionId: selectedOption.id });
        if (isDefined(selectedOption.onClick)) {
            selectedOption.onClick();
        }
        this.props.onSelectNewTimePeriodicity(selectedOption);
    }

    render() {
        const
            {
                options
            } = this.props;

        if (!options || !Array.isArray(options)) {
            return;
        }
        const buttons = options.map(o => {
            const optionStyle = this.state.selectedOptionId === o.id
                ? "flex-container-center option-in-box selected-option-in-box"
                : "flex-container-center option-in-box not-selected-option-in-box";
            return (<div className={optionStyle}
                key={o.id}
                onClick={() => this.onSelectOption(o)}>
                {o.value}
            </div>)
        });

        return (<>
            <div className="flex-container-start select-options-box">
                {buttons}
            </div>
        </>);
    };
}

const select = state => ({});
export default connect(select)(RadioOptions);

